import auth from '../helper/auth'

const adminRoutes = [
  {
    path: '/admin',
    component: () => import('../layouts/Admin.vue'),
    beforeEnter: auth.ifAuthenticated,
    children: [
      /* core */
      {
        path: '/',
        name: 'Dashboard',
        component: () => import('../views/admin/Dashboard.vue')
      },
      // Create list, both potential and actual
      {
        path: 'clients/:businessStatus',
        name: 'ClientsAdmin',
        component: () => import('../views/admin/ClientsAdmin.vue')
      },
      {
        path: 'client/create',
        name: 'CreateClientsAdmin',
        component: () => import('../views/admin/CreateClientsAdmin.vue')
      },
      {
        path: 'client/:ref',
        name: 'ClientsDetailsAdmin',
        component: () => import('../views/admin/ClientsDetailsAdmin.vue')
      },

      /* Billing */
      {
        path: 'billing/transactions',
        name: 'Transactions',
        component: () => import('../views/admin/billing/Transactions.vue')
      }
      /* 
      {
        path: 'ticket/:ref',
        name: 'TicketDetailsAdmin',
        component: () => import('../views/admin/TicketDetailsAdmin.vue')
      },

      {
        path: 'testing',
        name: 'TestingEditor',
        component: () => import('../views/admin/TestingEditor.vue')
      } */
    ]
  }
]

export default adminRoutes
